'use client'

import Image from 'next/image'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { MediaKitImages } from '@components/MediaKit/MediaKitMock'
import styles from './HeroImage.module.scss'

const HeroImage = () => {
  const { ref, animationClassName } = useAnimateOnVisible<HTMLDivElement>({
    animationDelayMs: 120,
  })
  return (
    <div ref={ref} className={`${styles.heroImage} ${animationClassName}`}>
      <Image src={MediaKitImages.hero} alt="Hero image" height={620} width={512} />
    </div>
  )
}

export default HeroImage
